export default function R_Median() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R_Median Component</h1>
      <p>This is the R_Median tutorial section.</p>
    </div>
  );
}
